/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OnboardingProfessionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
